import { render, staticRenderFns } from "./GravitationViz.vue?vue&type=template&id=4f3cdbce&scoped=true"
import script from "./GravitationViz.vue?vue&type=script&lang=js"
export * from "./GravitationViz.vue?vue&type=script&lang=js"
import style0 from "./GravitationViz.vue?vue&type=style&index=0&id=4f3cdbce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3cdbce",
  null
  
)

export default component.exports